import { Application } from "@hotwired/stimulus"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}

import { layoutControllers, railsEnv } from "@uenf/layout"
for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}

import { definitions } from "stimulus:./controllers"
application.load(definitions);

import AutocompleteController from "@uenf/layout/controllers/autocomplete";
application.register("autocomplete", AutocompleteController);

import AddressController from "@uenf/layout/controllers/address";
application.register("address", AddressController);
